<template>
    <div class="open-container">
        <div class="content-container">
            <div class="block-60"></div>
            <div class="main-tabs">
                <div class="container tab-content">
                    <div class="row tab-pane active" id="panel-1" style="height: 100%;">
                        <!-- tab1开始    -->
                        <div class="opendoc_left">
                            <div class="tools-nav white_bg">
                                <div class="menu">
                                    <h3 class="onleft">一. 平台介绍</h3>
                                    <ul class="ulmenu0" style="display: block;">
                                        <li>
                                            <a class="selected">平台简介</a>
                                        </li>
                                        <li>
                                            <a class>开放平台管理规则</a>
                                        </li>
                                    </ul>
                                    <h3 class>二. 开发者对接说明</h3>
                                    <ul class="ulmenu1" style="display: none;">
                                        <li>
                                            <a class>对接步骤</a>
                                        </li>
                                        <li>
                                            <a>公共参数说明</a>
                                        </li>
                                        <li>
                                            <a>Restful 介绍 & 全局返回码</a>
                                        </li>
                                    </ul>
                                    <h3 class>三. 接口列表</h3>
                                    <ul class="ulmenu2" style="display: none;">
                                        <li>
                                            <a class>添加设备</a>
                                        </li>
                                        <li>
                                            <a>获取设备信息</a>
                                        </li>
                                        <li>
                                            <a>设置设备信息</a>
                                        </li>
                                        <li>
                                            <a>删除设备</a>
                                        </li>
                                        <li>
                                            <a>小票机下发打印任务</a>
                                        </li>
                                        <li>
                                            <a>删除指定打印任务</a>
                                        </li>
                                        <li>
                                            <a>清空设备待打印任务</a>
                                        </li>
                                        <li>
                                            <a>查询打印任务状态</a>
                                        </li>
                                        <li id="callback">
                                            <a>打印成功后回调</a>
                                        </li>
                                        <li id="qm_href">
                                            <a>
                                                签名生成算法
                                            </a>
                                        </li>
                                    </ul>
                                    <h3 id="sdk_href">四. SDK 示例下载</h3>
                                    <ul class="ulmenu4" style>
                                        <li style="display: none;">
                                            <a class="selected"
                                                href="https://www.zonelink.cc/open/index.html#tab4-1">SDK
                                                示例下载</a>
                                        </li>
                                    </ul>
                                    <h3>五. 常见问题</h3>
                                    <ul class="ulmenu5" style>
                                        <li style="display: none;">
                                            <a class="selected"
                                                href="https://www.zonelink.cc/open/index.html#tab5-1">常见问题</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="opendoc_right white_bg">
                            <div class="content2_he">
                                <div class="get-menu">
                                    <h4 class="nav_title A1">平台介绍</h4>
                                </div>
                                <div class="menu0 menu_tab">
                                    <div id="tab1" class="tab active">
                                        <div class="spdown-body">
                                            <h3 class="content-title">平台简介</h3>
                                            <p>
                                                众联云打印开放平台，为开发者提供各行业的云打印解决方案，致力于成为国内最安全、稳定的云打印服务平台。
                                                <br />平台日均打印小票超过一百万，云打印解决方案可以有效提升商家经营效率、降低经营成本、提升市场竞争力、提高消费者的服务体验。
                                                <br />众联云打印开放平台提供完善的API开发文档以及示例，还有免费的技术支持服务。
                                                <br />接入众联云打印开放平台，让你的应用马上具备云打印功能，随时随地打印，不受距离限制。
                                                <br />
                                                <br />平台目前提供两种类型的设备支持：
                                                <br />
                                                <font color="blue">（1）普通WiFi / 4G 打印机</font>
                                                <br />
                                                <font color="blue">（2）云盒，一种可以连接蓝牙设备实现云打印的外设</font>
                                                <br />
                                                <br />
                                            </p>
                                            <p style="text-align: center;">
                                                <img src="/static/img/process.jpg" alt="云打印流程" style="width: 90%;" />
                                            </p>
                                        </div>
                                    </div>
                                    <div id="tab2" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">开放平台运营管理规则</h3>
                                            <h4 id class="subtitle">1.相关定义</h4>
                                            <p>
                                                <b>众联云打印开放平台</b>：众联云打印开放平台（以下简称“开放平台”），众联云，为第三方提供：技术文档、应用程序等相关服务，帮助其使用众联云打印服务。
                                            </p>
                                            <p>
                                                <b>第三方</b>：指与开放平台合作的任何第三方，包括但不限于个人开发者、企业开发者、以及个人或企业开发者的关联公司、合作方。
                                            </p>

                                            <h4 id class="subtitle">2.开放平台接入流程</h4>
                                            <h5 id class="subtitle">接入指南</h5>
                                            <p>第一步：注册（开发者的账号密码具有唯一性，开发者需对账号下的一切操作承担全部责任与法律后果）；</p>
                                            <p>第二步：阅读并确认了解《众联云打印开放平台服务条款》；</p>
                                            <p>第三步：完善第三方信息；</p>
                                            <p>第四步：根据接口文档进行开发；</p>
                                            <p>第五步：开发测试；</p>
                                            <p>第六步：上线；</p>

                                            <h4 id class="subtitle">3.免责声明</h4>
                                            <h5 id class="subtitle">条款</h5>
                                            <p>（1）对于使用了开放平台提供服务的第三方，必须遵守法律法规，如有违反，第三方同意独立承担所有的风险和后果。</p>
                                            <p>（2）第三方将使用了开放平台提供服务后的系统提供给最终用户使用时，应充分告知其相关注意事项。因任何人使用第三方开发或运营的系统所产生的任何问题、事故或纠纷，均由第三方自行承担全部责任，开放平台对此不承担责任。
                                            </p>
                                            <p>（3）开放平台因本条前述事由受到损失或者被要求承担责任的，有权要求相应第三方赔偿开放平台因此受到的损失和/或要求该开发者承担相关责任。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="menu1 menu_tab">
                                    <div id="tab1" class="tab">
                                        <h4 style="font-weight:normal;">
                                            开发者接入API步骤如下，如对接遇到问题，请加众联云技术支持微信咨询（请务必备注<font color="red">“开放平台对接”</font>）：
                                        </h4>
                                        <img class="tech-qrcode" src="/static/img/tech.jpg" alt="">
                                        <br />
                                        <p></p>
                                        <h4 class="bg-h4">第一步：注册开发者账号</h4>
                                        <p class="tab_mb" style="color:#999; border-radius: 0 0 5px 5px">
                                            到
                                            <a class="font_0071" href="/login"
                                                target="_blank">https://www.zonelink.cc/login</a>
                                            （以下统称‘众联云开放后台’）注册开发者账号。
                                        </p>
                                        <br />
                                        <h4 class="bg-h4">第二步：对接API（HTTPS协议）</h4>
                                        <p class="tab_mb" style="color:#999; border-radius: 0 0 5px 5px">
                                            注意:建议先调用添加设备接口，然后再调用打印接口进行打印，这样您可以在开放平台的管理后台查看打印记录。所有API接口都是<font
                                                color="red">
                                                https </font>
                                            协议。<br /><br />
                                            1、 <font color="red">【必接】</font>绑定设备到开发者账户
                                        </p>
                                        <br />
                                        <h4 class="bg-h4">第三步：测试打印</h4>
                                        <p class="tab_mb" style="color:#999; border-radius: 0 0 5px 5px">
                                            测试打印之前，请确保设备在线，并且纸张正常。如调试打印模板有问题，请扫描上方技术支持二维码添加技术对接工作人员进行咨询。</p>
                                        <p></p>
                                    </div>
                                    <div id="tab2" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">请求公共参数</h3>
                                        </div>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br /><br />
                                        <div class="spdown-body">
                                            <h3 class="content-title">返回公共参数</h3>
                                        </div>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                                <tr>
                                                    <td>data</td>
                                                    <td>object</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        数据类型和内容详看私有返回参数data
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab3" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">Restful API 介绍</h3>
                                        </div>
                                        <p class="tab_mb f14">
                                            Restful API本质就是发送 HTTP 请求，只不过大家常用的可能是 HTTP GET 和 HTTP POST 请求，但是在 Restful
                                            API里面还经常用到
                                            HTTP PUT 、HTTP PACTCH、 HTTP DELETE。
                                            <br />在 Restful
                                            API中，把这五种操作称之为动词，可以（但不是特别准确）想象成增删改查。客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                            <br />Restful API 接口调用成功时返回 HTTP 状态码为 200，如调用错误会返回除 200 之外的其他 HTTP
                                            状态码，可根据返回数据中的
                                            code和msg 字段判断具体错误。
                                            <br />
                                            <font color="red">常见HTTP错误状态码如下：</font>
                                        </p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>HTTP 返回码（Status Code）</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>400</td>
                                                    <td>（错误请求）服务器不理解请求的语法。</td>
                                                </tr>
                                                <tr>
                                                    <td>401</td>
                                                    <td>（未授权）请求要求身份验证。对于需要sign的接口，服务器可能返回此响应。</td>
                                                </tr>
                                                <tr>
                                                    <td>403</td>
                                                    <td>（禁止）服务器拒绝请求。</td>
                                                </tr>
                                                <tr>
                                                    <td>404</td>
                                                    <td>（未找到）服务器找不到请求的接口。</td>
                                                </tr>
                                                <tr>
                                                    <td>408</td>
                                                    <td>（请求超时）服务器等候请求时发生超时。</td>
                                                </tr>
                                                <tr>
                                                    <td>413</td>
                                                    <td>（请求体过大）拆成更小的请求体重试即可。</td>
                                                </tr>
                                                <tr>
                                                    <td>500</td>
                                                    <td>（服务器内部错误）请求参数不正确或服务器遇到错误，无法完成请求。</td>
                                                </tr>
                                                <tr>
                                                    <td>501</td>
                                                    <td>（尚未实施）服务器不具备完成请求的功能。例如，服务器无法识别请求方法时可能会返回此代码。</td>
                                                </tr>
                                                <tr>
                                                    <td>502</td>
                                                    <td>（错误网关）服务器作为网关或代理，从上游服务器收到无效响应。</td>
                                                </tr>
                                                <tr>
                                                    <td>503</td>
                                                    <td>（服务不可用）请求接口超过调用频率限制，即接口被限流。</td>
                                                </tr>
                                                <tr>
                                                    <td>504</td>
                                                    <td>（网关超时）服务器作为网关或代理，但是没有及时从上游服务器收到请求。</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div>
                                            更多 Restful API 背景知识可以参考
                                            <a class="blue"
                                                href="https://www.ruanyifeng.com/blog/2014/05/restful_api.html"
                                                target="_blank">Restful API 设计指南。</a>
                                        </div>
                                        <br />
                                        <h4>全局code如下：</h4>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>0</td>
                                                    <td>成功</td>
                                                </tr>
                                                <tr>
                                                    <td>-1</td>
                                                    <td>请求参数不正确</td>
                                                </tr>
                                                <tr>
                                                    <td>-2</td>
                                                    <td>appid不存在</td>
                                                </tr>
                                                <tr>
                                                    <td>-3</td>
                                                    <td>签名错误</td>
                                                </tr>
                                                <tr>
                                                    <td>-4</td>
                                                    <td>请求超时</td>
                                                </tr>
                                                <tr>
                                                    <td>10000</td>
                                                    <td>开发者信息错误</td>
                                                </tr>
                                                <tr>
                                                    <td>大于0</td>
                                                    <td>错误码大于0时每个接口返回不一样，具体请看各个接口</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="menu2 menu_tab">
                                    <div id="tab-1" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">添加设备</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/add</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">POST</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sn</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备编号(可查看设备侧边或底部标签)</td>
                                                </tr>
                                                <tr>
                                                    <td>name</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备名称/备注</td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">0</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span class="lit">"ok"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p></p>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>设备编号为空</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>设备KEY为空</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>设备名称为空</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>设备编号或KEY错误</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>此设备已添加，不能重复添加</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>系统繁忙</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-2" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">获取设备信息</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/info</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">GET</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求URL参数：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sn</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备编号(可查看设备侧边或底部标签)</td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                                <tr>
                                                    <td>data</td>
                                                    <td>object</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        数据类型和内容详看私有返回参数data
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ id</td>
                                                    <td>long</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        设备ID
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ sn</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        设备编号
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ name</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        设备名称
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ type</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        设备类型，1：打印机，2：云盒
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ width</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        纸宽，目前只有两个规格 58 或 80
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ iccid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>
                                                        流量卡号，WiFi机型该值为空
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ online</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        设备是否在线，1：在线，0：离线
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ status</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        设备自身状态，1：正常，0：异常
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ toPrintCount</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        待打印任务数，默认 0
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ cutAble</td>
                                                    <td>boolean</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        是否带切刀，true：带切刀，false：不带切刀
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ vocAble</td>
                                                    <td>boolean</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        语音播报开关，true：播报语音，false：不播报语音
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span>0</span><span class="pun">,</span></span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"ok"</span><span class="pun">,</span></span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"data"</span></span><span class="pun">:</span><span class="str"><span> {</span></span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"id"</span></span><span class="pun">:</span><span class="str"><span class="lit">1</span></span><span class="pun">,</span>               <span class="c666">// 设备编号</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"sn"</span></span><span class="pun">:</span><span class="str"><span class="lit">"Hy7Imeya17id"</span></span><span class="pun">,</span>  <span class="c666">// 设备编号</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"name"</span></span><span class="pun">:</span><span class="str"><span class="lit">"zonelink"</span></span><span class="pun">,</span>    <span class="c666">// 设备名称</span></code></li><li
    class="L3"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"type"</span></span><span class="pun">:</span><span class="str"><span class="lit">1</span></span><span class="pun">,</span>             <span class="c666">// 设备类型，1：打印机，2：云盒</span></code></li><li
    class="L3"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"width"</span></span><span class="pun">:</span><span class="str"><span class="lit">58</span></span><span class="pun">,</span>           <span class="c666">// 纸宽，目前只有两个规格 58 和 80</span></code></li><li
    class="L3"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"imsi"</span></span><span class="pun">:</span><span class="str"><span class="lit">"xxx"</span></span>          <span class="c666">// 流量卡号码,wifi机型该值为空</span></code></li><li
    class="L4"
><code class="hljs"><span class="pln">              </span><span class="str"><span class="hljs-string">"online"</span></span><span class="pun">:</span><span class="str"><span class="lit">1</span></span><span class="pun">,</span>           <span class="c666">// 是否在线，1：在线：0：离线</span></code></li><li
    class="L5"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"status"</span></span><span class="pun">:</span><span class="str"><span class="lit">0</span></span><span class="pun">,</span>           <span class="c666">// 状态，1：正常，0：异常</span></code></li><li
    class="L6"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"toPrintCount"</span></span><span class="pun">:</span><span class="str"><span class="lit">1</span></span><span class="pun">,</span>     <span class="c666">// 待打印任务数</span></code></li><li
    class="L7"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"cutAble"</span></span><span class="pun">:</span><span class="str"><span class="lit">false</span></span><span class="pun">,</span>      <span class="c666">// 是否带切刀，true：带切刀，false：不带切刀</span></code></li><li
    class="L8"
><code class="hljs bash"><span class="pln">              </span><span class="str"><span class="hljs-string">"vocAble"</span></span><span class="pun">:</span><span class="str"><span class="lit">true</span></span><span class="pun">,</span>       <span class="c666">// 语音播报开关，true：播报语音，false：不播报语音</span></code></li><li
    class="L9"
><code class="hljs bash"><span class="pln">       </span><span class="str"><span class="lit">}</span></span></code></li><li
    class="L9"
><code class="hljs bash"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>设备不存在</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>系统繁忙</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-3" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">设置设备信息</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/setting</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">PUT</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sn</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备编号</td>
                                                </tr>
                                                <tr>
                                                    <td>name</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>修改设备名称
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>width</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>
                                                        <font style="color: blue;font-weight: bolder;"> 【注意】</font>
                                                        修改设备纸宽，仅限设备是<font style="color: red;font-weight: bolder;"> 云盒
                                                        </font>的时候才生效
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>cutAble</td>
                                                    <td>boolean</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>
                                                        <font style="color: blue;font-weight: bolder;"> 【注意】</font>
                                                        修改设备是否有切刀，仅限设备是<font style="color: red;font-weight: bolder;"> 云盒
                                                        </font>的时候才生效
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>vocAble</td>
                                                    <td>boolean</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>设置是否播报语音，true：播报语音，false：不播报语音
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">0</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span class="lit">"ok"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>设备不存在</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>非云盒纸宽设置无效</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>非云盒切刀设置无效</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>至少必须存在一项编辑项</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>系统繁忙</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-4" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">删除设备</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/delete</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">DELETE</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sn</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备编号</td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">0</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span class="lit">"ok"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>设备不存在</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>系统繁忙</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-5" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">小票机下发打印任务</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/task/add</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">POST</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sn</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备编号(查看设备侧边或底部标签)</td>
                                                </tr>
                                                <tr>
                                                    <td>orderNo</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td style="font-weight: bold;">【重要】订单编号，开发者自有系统的订单编号，若需回调打印结果 或
                                                        主动查询打印任务状态<font color="red">必填</font>，开发者自己保证<font color="red">
                                                            唯一
                                                        </font>性
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>content</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>打印内容，最大支持 4000 字节（中文按照2字节计算）</td>
                                                </tr>
                                                <tr>
                                                    <td>delay</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>延迟打印<font color="red">（单位：秒）</font>，默认为 0，云平台接收到打印任务立即执行</td>
                                                </tr>
                                                <tr>
                                                    <td>expiredDay</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>打印任务过期时间<font color="red">（单位：天）</font>，默认为
                                                        1，N天内目标打印设备没有执行打印则任务自动丢弃
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                                <tr>
                                                    <td>data</td>
                                                    <td>object</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        数据类型和内容详看私有返回参数data
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ createTime</td>
                                                    <td>date</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        任务接收时间
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ orderNo</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        订单编号
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <p class="t_h5">
                                            <font color="blue">小票排版控制标签说明：(详情请参考SDK示例)</font>
                                        </p>
                                        <pre
                                            class="prettyprint linenums prettyprinted"><ol class="linenums"><li v-for="item in $printTags" :key="item.label"><span class="hljs-string"> {{ item.label }} </span>：{{ item.tips }}</li></ol></pre>

                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span>0</span></span><span class="pun">,</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"ok"</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"data"</span></span><span class="pun">:</span><span class="str"><span>{</span></span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">             </span><span class="str"><span class="hljs-string">"createTime"</span></span><span class="pun">:</span><span class="str"><span>"2022-10-10 00:00:00"</span></span><span
    class="pun"
>,</span></code></li><li
    class="L3"
><code class="hljs bash"><span class="pln">             </span><span class="str"><span class="hljs-string">"orderNo"</span></span><span class="pun">:</span><span class="str"><span>"2022101000001"         // 如果开发者不传入，云平台会自动生成订单号，但是打印结果不会回调</span></span></code></li><li
    class="L9"
><code class="hljs"><span class="pln">      </span><span class="str"><span>}</span></span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>设备编号SN不正确</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>打印内容为空</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>打印内容长度超过4000字节</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>需要回调所以客户订单号不可为空</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>设备不存在</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>订单号长度超过64</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-5" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">删除指定打印任务</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/task/delete</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">DELETE</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>orderNo</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>打印任务订单号，<font color="red">开发者自有系统的订单编号</font>，下发打印任务时传入
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">0</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span class="lit">"ok"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>暂无权限</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>设备不存在</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-6" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">清空指定设备待打印任务</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/task/clean</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">DELETE</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>sn</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>设备编号</td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                                <tr>
                                                    <td>data</td>
                                                    <td>object</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        数据类型和内容详看私有返回参数data
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ count</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        清空的任务数
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span>0</span></span><span class="pun">,</span> </code><code
    class="hljs bash"
><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"ok"</span></span><span class="pun">,</span> </code><code
    class="hljs bash"
><span class="pln">      </span><span class="str"><span class="hljs-string">"data"</span></span><span class="pun">:</span><span class="str"><span>{</span></span></code><code
    class="hljs bash"
><span class="pln">             </span><span class="str"><span class="hljs-string">"count"</span></span><span class="pun">:</span><span class="str"><span>10</span></span></code></li><li
    class="L9"
><code class="hljs"><span class="pln">      </span><span class="str">}</span></code><code
    class="hljs bash"
><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>暂无权限</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>设备不存在</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-7" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">查询打印任务状态</h3>
                                        </div>
                                        <p class="t_h5">请求url：</p>
                                        <p class="tab_mb">https://open.zonelink.cc/v1/printer/task/status</p>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">GET</p>
                                        <p class="t_h5">请求数据说明：</p>
                                        <p class="tab_mb">
                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。
                                        </p>
                                        <p class="t_h5">请求URL参数：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>orderNo</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>打印任务订单号，<font color="red">开发者自有系统的订单编号</font>，下发打印任务时传入
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">返回参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>code</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零</td>
                                                </tr>
                                                <tr>
                                                    <td>msg</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>结果提示信息，正确返回“ok”，如果有错误，返回错误信息</td>
                                                </tr>
                                                <tr>
                                                    <td>data</td>
                                                    <td>object</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        数据类型和内容详看私有返回参数data
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ status</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        打印任务状态，0：待发送至设备，1：已下发至设备，2：设备已接收，3：打印完成，4：被删除，5：延迟打印
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ delay</td>
                                                    <td>int</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>
                                                        延迟打印剩余时间，当 status=5 时返回，单位：秒
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;└ printTime</td>
                                                    <td>date</td>
                                                    <td>
                                                        <font color="blue">否</font>
                                                    </td>
                                                    <td>
                                                        打印任务完成时间，当 status=3 时返回
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">成功返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span>0</span></span><span class="pun">,</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"ok"</span></span><span class="pun">,</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"data"</span></span><span class="pun">:</span><span class="str">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">             </span><span class="str"><span class="hljs-string">"status"</span></span><span class="pun">:</span><span class="str"><span>3</span></span><span class="pun">,</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">             </span><span class="str"><span class="hljs-string">"printTime"</span></span><span class="pun">:</span><span class="str"><span>"2022-10-10 00:00:00"</span></span></code></li><li
    class="L9"
><code class="hljs"><span class="pln">      </span><span class="str"><span>}</span></span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">  </span><span class="pun">}</span></code></li></ol>
                                </pre>
                                        <p class="t_h5">失败返回：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"code"</span></span><span class="pun">:</span><span class="str"><span class="lit">-1</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"msg"</span></span><span class="pun">:</span><span class="str"><span>"appid为空"</span></span></code></li><li
    class="L3"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">本接口code说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>code</th>
                                                    <th>说明（Description）</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>订单号为空</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>查无此订单号对应的打印任务</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>延迟打印失败</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div id="tab-8" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">打印成功后回调</h3>
                                        </div>
                                        <div class="callback-container">
                                            <div>
                                                【说明】此接口是云服务器主动向开发者服务器回传打印任务状态。
                                            </div>
                                            <div>
                                                【编码】发送的数据类型为：application/json，数据编码为：UTF-8。
                                            </div>
                                            <div>
                                                【前提】需要在开发者后台<font color="red">配置</font>打印任务状态<font color="blue">回调地址
                                                </font>
                                                ，且调用
                                                <font color="blue">“下发打印任务”</font>接口时务必传入<font color="red">orderNo
                                                </font>。
                                            </div>
                                            <div>
                                                【安全】开发者需要根据签名算法对回调地址接收到的数据做安全校验。
                                            </div>
                                        </div>
                                        <p class="t_h5">请求方法：</p>
                                        <p class="tab_mb">POST</p>
                                        <p class="t_h5">请求响应：</p>
                                        <p class="tab_mb">
                                            开发者接收后需立即返回 <font color="red">SUCCESS</font>
                                            ，如5秒内不返回或返回数据格式错误，云平台会重新推送，最多重推3次。
                                        </p>
                                        <p class="t_h5">请求参数说明：</p>
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>参数名</th>
                                                    <th>类型</th>
                                                    <th>是否必须</th>
                                                    <th>说明</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>appid</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>用户唯一凭证</td>
                                                </tr>
                                                <tr>
                                                    <td>timestamp</td>
                                                    <td>long</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>请求时unix时间戳(10位数字，精确到秒)</td>
                                                </tr>
                                                <tr>
                                                    <td>orderNo</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td style="font-weight: bold;">开发者自有系统的订单编号，开发者自己保证<font
                                                            color="red"> 唯一
                                                        </font>性
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>sign</td>
                                                    <td>string</td>
                                                    <td>
                                                        <font color="red">是</font>
                                                    </td>
                                                    <td>
                                                        签名，
                                                        <a href="javascript:;" class="qm_href">详见签名生成算法</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="t_h5">开发者响应返回示例：</p>
                                        <p class="tab_mb">SUCCESS</p>
                                    </div>
                                    <div id="tab-9" class="tab">
                                        <div class="spdown-body">
                                            <h3 class="content-title">签名生成算法</h3>
                                        </div>
                                        <p class="t_h5">签名生成的通用步骤如下：</p>
                                        <p>
                                            <b>第一步：</b>设所有发送或者接收到的数据为集合M，将集合M内非空参数值的参数按照参数名ASCII码从小到大排序（字典序），使用URL键值对的格式（即key1=value1&amp;key2=value2…）拼接成字符串
                                            paramString。
                                        </p>
                                        <br />
                                        <p class="t_h5">特别注意以下重要规则：</p>
                                        <p class="tab_mb">
                                            ◆ 参数名ASCII码从小到大排序（字典序）；
                                            <br />◆ 如果参数的值为空不参与签名，注意为空指空字符串，"0"不为空字符串，需参与签名；
                                            <br />◆ 参数名区分大小写；
                                            <br />◆ 验证调用返回或微信主动通知签名时，传送的sign参数不参与签名，将生成的签名与该sign值作校验。
                                        </p>
                                        <p>
                                            <b>第二步：</b>在 paramString 最后拼接上<font color="red"> appsecret </font>
                                            得到 signString 字符串，并对 signString 进行MD5运算，再将得到的字符串所有字符转换为大写，得到 sign 值
                                            signValue。
                                        </p>
                                        <p class="t_h5">举例：</p>
                                        <p class="t_h5">假设传送的参数如下：</p>
                                        <pre class="prettyprint linenums prettyprinted f14"><ol class="linenums"><li class="L0"><code class="hljs"><span class="pln">  </span><span class="pun">{</span></code></li><li
    class="L1"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"appid"</span></span><span class="pun">:</span><span class="str"><span class="hljs-string">"jSOrPqkMuxff"</span></span><span class="pun">,</span></code></li><li
    class="L2"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"timestamp"</span></span><span class="pun">:</span><span class="str"><span class="hljs-string">"1664267034"</span></span><span class="pun">,</span></code></li><li
    class="L3"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"sn"</span></span><span class="pun">:</span><span class="str"><span class="hljs-string">"Hy7Imeya17id"</span></span><span class="pun">,</span></code></li><li
    class="L4"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"key"</span></span><span class="pun">:</span><span class="str"><span class="hljs-string">"nBx3XNuXsnTDWSzJ"</span></span><span class="pun">,</span></code></li><li
    class="L5"
><code class="hljs bash"><span class="pln">      </span><span class="str"><span class="hljs-string">"name"</span></span><span class="pun">:</span><span class="str"><span class="hljs-string">"zonelink"</span></span></code></li><li
    class="L6"
><code class="hljs"><span class="pln">  </span><span class="pun">}</span></code></li></ol></pre>
                                        <p class="t_h5">
                                            <b>第一步：</b>对参数按照key=value的格式，并按照参数名ASCII字典序排序如下：
                                        </p>
                                        <p class="tab_mb">
                                            paramString =
                                            "appid=jSOrPqkMuxff&amp;key=nBx3XNuXsnTDWSzJ&amp;name=zonelink&amp;sn=Hy7Imeya17id&amp;timestamp=1664267034";
                                        </p>
                                        <p class="t_h5">第二步：拼接API密钥：</p>
                                        <p class="tab_mb">
                                            signString = "paramString&amp;appsecret=WjHdVQ8n7heUUbrKDsNU8Wj5iO6rGRTq"
                                            <br />sign = MD5(signString).toUpperCase()
                                            <br />得到最终结果：<font color="red">F35BED40E66CF30C896ECF34D145C1E2</font>
                                        </p>

                                        <p class="t_h5" style="color: blue;">注意：appid 和 appsecret 的值，请登陆管理后台查看开发者信息</p>
                                    </div>
                                </div>
                                <div class="menu4 menu_tab">
                                    <div id="tab4-1" class="tab">
                                        <div class="clearfix row">
                                            <div class="col-md-3">
                                                <div class="thumbnail">
                                                    <img class="img-circle" src="/static/img/java.jpg" />
                                                    <div class="caption">
                                                        <h4>众联云API-Java版</h4>
                                                        <p>
                                                            <a class="btn btn-un_default"
                                                                href="https://static.zonelink.cc/openapi-sdk/java-sdk.zip"
                                                                target="_blank">点击下载</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="thumbnail">
                                                    <img class="img-circle" src="/static/img/php.jpg" />
                                                    <div class="caption">
                                                        <h4>众联云API-PHP版</h4>
                                                        <p>
                                                            <a class="btn btn-un_default"
                                                                href="https://static.zonelink.cc/openapi-sdk/php-sdk.zip"
                                                                target="_blank">点击下载</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="thumbnail">
                                                    <img class="img-circle" src="/static/img/nodejs.jpg" />
                                                    <div class="caption">
                                                        <h4>众联云API-NodeJS版</h4>
                                                        <p>
                                                            <a class="btn btn-un_default"
                                                                href="https://static.zonelink.cc/openapi-sdk/nodejs-sdk.zip"
                                                                target="_blank">点击下载</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="thumbnail">
                                                    <img class="img-circle" src="/static/img/python.jpg" />
                                                    <div class="caption">
                                                        <h4>众联云API-Python版</h4>
                                                        <p>
                                                            <a class="btn btn-un_default"
                                                                href="https://static.zonelink.cc/openapi-sdk/python-sdk.zip"
                                                                target="_blank">点击下载</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="thumbnail">
                                                    <img class="img-circle" src="/static/img/weixin.jpg" />
                                                    <div class="caption">
                                                        <h4>众联云API-微信小程序版</h4>
                                                        <p>
                                                            <a class="btn btn-un_default"
                                                                href="https://static.zonelink.cc/openapi-sdk/wx-sdk.zip"
                                                                target="_blank">点击下载</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="alert alert-warning m20 tc">
                                            <div style="margin-top: 20px;">如有其他技术问题，请扫描下方技术支持二维码添加技术对接工作人员进行咨询。</div>
                                            <img class="tech-qrcode" style="margin-bottom: 30px;"
                                                src="/static/img/tech.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div class="menu5 menu_tab">
                                    <div id="tab5-1" class="tab">
                                        <div class="clearfix row help">
                                            <div class="col-md-12">
                                                <div class="content2_he">
                                                    <div class="column">
                                                        <div class="panel-group" id="panel">
                                                            <div class="panel panel-default current">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        1、VIP开发者和普通开发者的区别
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">VIP开发者有更多的接口权限，更长的订单保存时间等功能。
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        2、设备单行打印多少个字符
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">众联云58mm系列云设备,一行打印16个汉字/32个字母
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        3、如何设置订单小票格式
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">参考开发文档,“打印任务”接口</div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        4、二维码的大小是否可以调整
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">大小不能调整,根据内容的长度,动态生成</div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        5、4G型号机器需要充值吗
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">要，机器从购买日起，送一年的4G流量费，过期后需要充值。
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        6、无线设备断网了，订单会漏吗
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">
                                                                        不会漏单，由于网络异常情况导致设备离线，设备会不断的自动重连，订单是缓存在服务器上面的，机器重新联网后会继续打印之前未打印的订单。
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        7、打印任务的时候,刚好没纸了,会自动补打吗
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">会,重新装上纸后,会重新补打一份。</div>
                                                                </div>
                                                            </div>
                                                            <div class="panel panel-default">
                                                                <div class="panel-heading">
                                                                    <a class="panel-title">
                                                                        8、机器出现故障如何保修
                                                                        <i class="fa fa-caret-down"></i>
                                                                    </a>
                                                                </div>
                                                                <div class="panel-collapse panel-coll2">
                                                                    <div class="panel-body">
                                                                        先电话或微信咨询客服，确认问题，非人为因素机器免费保修一年。人为因素要收取一定维修费用。维修统一寄回工厂处理。
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- tab1结束   -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import $ from 'jquery'
export default {
    data() {
        return {}
    },
    mounted() {
        $(document).ready(function () {
            function myfunction(li, li_a, menu_tab) {
                li.click(function () {
                    var index = $(this).index();
                    menu_tab.eq(index).addClass("active").siblings().removeClass("active");
                    li_a.removeClass("selected");
                    li_a.eq(index).addClass("selected").siblings().removeClass("selected");
                });
            }
            myfunction($(".container .menu .ulmenu0 li"), $(".container .ulmenu0 li a"), $(".container .content2_he .menu0 .tab"));
            myfunction($(".container .menu .ulmenu1 li"), $(".container .ulmenu1 li a"), $(".container .content2_he .menu1 .tab"));
            myfunction($(".container .menu .ulmenu2 li"), $(".container .ulmenu2 li a"), $(".container .content2_he .menu2 .tab"));
            myfunction($(".container .menu .ulmenu3 li"), $(".container .ulmenu3 li a"), $(".container .content2_he .menu3 .tab"));
            myfunction($(".container .menu .ulmenu4 li"), $(".container .ulmenu4 li a"), $(".container .content2_he .menu4 .tab"));
            myfunction($(".container .menu .ulmenu5 li"), $(".container .ulmenu5 li a"), $(".container .content2_he .menu5 .tab"));
            myfunction($(".container .menu .ulmenu6 li"), $(".container .ulmenu6 li a"), $(".container .content2_he .menu6 .tab"));
            $(function () {
                $(".menu > ul").eq(0).show();
                $(".menu h3").click(function () {
                    $(this).addClass("onleft").siblings().removeClass('onleft');
                    $(".menu_tab > div").removeClass("active");
                    var val = ($(this).next().attr('class'));
                    var menu_value = (val.substring(val.length - 1));
                    $(".container .content2_he .menu" + menu_value + " .tab:first-child").addClass("active");
                    $(".container .menu .ulmenu" + menu_value + " li>a").removeClass("selected");
                    $(".container .menu .ulmenu" + menu_value + " li a").eq(0).addClass("selected");
                    $(this).next().stop().slideToggle();
                    $(this).siblings().next("ul").stop().slideUp();
                });
            });
            $(function () {
                $(".container .menu > h3").click(function () {
                    $(".container .content2_he .A1").empty().text($(this).text());
                });
            });
        });
        $(function () {
            $(".panel .panel-collapse panel-coll2:eq(0)").show();
            $(".panel").click(function () {
                $(this).siblings('.panel').removeClass('current');
                $(this).toggleClass('current');
            });
        });
        $(function () {
            $(".qm_href").click(function () {
                $(".onleft").removeClass("onleft");
                $(".menu > ul").hide();
                $(".menu_tab > div").removeClass("active");
                $(".menu > ul").eq(2).show();
                $(".menu > h3").eq(2).addClass("onleft");
                $("#qm_href").click();
                $(".container .content2_he .A1").empty().text($(".menu > h3").eq(2).text());
            });
        });
    },
    methods: {
        showCallback() {
            $(".menu h3").eq(2).click();
            $("#callback").click();
        }
    }
}
</script>


<style scoped>
.open-container {
    background-color: black;
}

.content-container {
    height: 100vh;
    background-color: #fff;
    display: flex;
    flex-direction: column;
}

.container .menu h3 {
    text-align: left;
}

.caption p {
    text-align: center !important;
}

.panel-body {
    text-align: left;
    padding: 20px;
}

table td {
    text-align: left;
}

.subtitle {
    text-align: left;
}

.tech-qrcode {
    width: 200px;
    margin-top: 10px;
    margin-bottom: 50px;
}

.callback-container {
    padding: 15px;
    background-color: #fff8eb;
    border: solid 1px #ffd6b1;
    border-left: 5px solid #ff7800;
    margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// open.vue?5fd3f21e